// import React, { useState } from "react";
// import { Table, TableHead, TableHeaderCell, TableBody, TableRow, TableCell, TableEmptyState, TableActionButton, PrimaryButton, SearchContainer, ResultsSummary, Pagination, Modal } from "../ui";

// // import { Table, TableHead, TableBody, TableRow, TableCell, TableEmptyState, TableActionButton, PrimaryButton } from "../UI/Table";
// import AddChildModal from "./modals/AddChildModal";
// import ConfirmModal from "./ConfirmModal";

// export const ExpandedAccordion = ({ sections, onSectionsUpdate }) => {
//   const [openSections, setOpenSections] = useState({});
//   const [isAddChildModalOpen, setIsAddChildModalOpen] = useState(false);
//   const [currentSectionId, setCurrentSectionId] = useState(null);
//   const [childData, setChildData] = useState({});
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [childToDelete, setChildToDelete] = useState({ sectionId: null, index: null });

//   const toggleSection = (id) => setOpenSections((prev) => ({ ...prev, [id]: !prev[id] }));

//   const handleAddChildClick = (sectionId) => {
//     setCurrentSectionId(sectionId);
//     setChildData({});
//     setIsAddChildModalOpen(true);
//   };

//   const handleSaveChild = () => {
//     const section = sections.find((s) => s.id === currentSectionId);
//     if (!section) return;
//     section.children = [...(section.children || []), childData];
//     onSectionsUpdate([...sections]);
//     setIsAddChildModalOpen(false);
//   };

//   const handleDeleteClick = (sectionId, index) => {
//     setChildToDelete({ sectionId, index });
//     setIsDeleteModalOpen(true);
//   };

//   const handleConfirmDelete = () => {
//     const { sectionId, index } = childToDelete;
//     const section = sections.find((s) => s.id === sectionId);
//     if (section) {
//       section.children = section.children.filter((_, i) => i !== index);
//       onSectionsUpdate([...sections]);
//     }
//     setChildToDelete({ sectionId: null, index: null });
//     setIsDeleteModalOpen(false);
//   };

//   return (
//     <div className="space-y-4 w-full bg-gray-50 p-4">
//       {sections.map((section) => (
//         <div key={section.id} className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
//           {/* Header */}
//           <button onClick={() => toggleSection(section.id)} className="bg-[#f1f1f1] w-full px-4 py-3 text-left flex items-center justify-between focus:outline-none">
//             <h4 className="text-sm font-semibold text-gray-900">{section.title}</h4>
//             <span className="w-6 h-6 rounded-full bg-[#4d4a4a] text-white flex items-center justify-center text-sm">{openSections[section.id] ? "-" : "+"}</span>
//           </button>

//           {/* Content */}
//           {openSections[section.id] && (
//             <div className="px-4 pb-4 border-t">
//               {section.isChildrenSection ? (
//                 <>
//                   <Table>
//                     <TableHead>
//                       <TableRow>
//                         {["Child", "Age", "Gender", "DOB", "Weight", "Blood Group", "Actions"].map((header) => (
//                           <TableCell key={header}>{header}</TableCell>
//                         ))}
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {section.children && section.children.length > 0 ? (
//                         section.children.map((child, index) => (
//                           <TableRow key={index}>
//                             {["name", "age", "gender", "dateOfBirth", "weight", "bloodGroup"].map((field) => (
//                               <TableCell key={field}>{field === "dateOfBirth" && child[field] ? new Date(child[field]).toLocaleDateString() : child[field] || "—"}</TableCell>
//                             ))}
//                             <TableCell>
//                               <TableActionButton onClick={() => handleDeleteClick(section.id, index)} variant="danger" tooltip="Delete Child" />
//                             </TableCell>
//                           </TableRow>
//                         ))
//                       ) : (
//                         <TableEmptyState title="No children added" action={() => handleAddChildClick(section.id)} actionLabel="Add Child" />
//                       )}
//                     </TableBody>
//                   </Table>

//                   {section.children && section.children.length > 0 && (
//                     <div className="pt-4 text-center">
//                       <PrimaryButton onClick={() => handleAddChildClick(section.id)}>Add Another Child</PrimaryButton>
//                     </div>
//                   )}
//                 </>
//               ) : (
//                 <div className="grid grid-cols-2 gap-4 pt-3">
//                   {section.fields?.map((field, i) => (
//                     <div key={i} className={field.isLong ? "col-span-2" : ""}>
//                       <span className="text-sm text-[#74777F]">{field.label}:</span>
//                       {field.isLong ? <p className="text-sm font-medium text-[#232526] mt-1">{field.value}</p> : <div className="text-sm font-medium text-[#232526]">{field.value}</div>}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       ))}

//       {/* Add Child Modal */}
//       <AddChildModal isOpen={isAddChildModalOpen} onClose={() => setIsAddChildModalOpen(false)} childData={childData} setChildData={setChildData} onSave={handleSaveChild} />

//       {/* Confirm Delete Modal */}
//       <ConfirmModal
//         isOpen={isDeleteModalOpen}
//         title="Delete Child"
//         message={`Are you sure you want to delete ${childToDelete.index !== null ? sections.find((s) => s.id === childToDelete.sectionId)?.children[childToDelete.index]?.name : "this child"}?`}
//         confirmLabel="Delete"
//         cancelLabel="Cancel"
//         onCancel={() => setIsDeleteModalOpen(false)}
//         onConfirm={handleConfirmDelete}
//       />
//     </div>
//   );
// };
// import React, { useState } from "react";
// import { Table, TableHead, TableBody, TableRow, TableCell, TableEmptyState, TableActionButton, PrimaryButton } from "../ui";
// import AddChildModal from "./modals/AddChildModal";
// import ConfirmModal from "./ConfirmModal";
// import Baby from "../../../assets/images/baby.png";

// export const ExpandedAccordion = ({ sections = [], item, onSectionsUpdate, onChildUpdate, onOpenModal }) => {
//   const [openSections, setOpenSections] = useState({});
//   const [isAddChildModalOpen, setIsAddChildModalOpen] = useState(false);
//   const [currentSectionId, setCurrentSectionId] = useState(null);
//   const [childData, setChildData] = useState({});
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [childToDelete, setChildToDelete] = useState({ sectionId: null, index: null });

//   const toggleSection = (id) => setOpenSections((prev) => ({ ...prev, [id]: !prev[id] }));

//   const handleAddChildClick = (sectionId) => {
//     setCurrentSectionId(sectionId);
//     setChildData({});
//     setIsAddChildModalOpen(true);
//   };

//   const handleSaveChild = () => {
//     const updatedSections = sections.map((section) => (section.id === currentSectionId ? { ...section, children: [...(section.children || []), childData] } : section));
//     onSectionsUpdate(updatedSections);

//     // Update parent table
//     if (onChildUpdate) {
//       const updatedParent = { ...item, children: updatedSections.find((s) => s.id === currentSectionId)?.children || [] };
//       onChildUpdate(updatedParent);
//     }

//     setIsAddChildModalOpen(false);
//   };

//   const handleDeleteClick = (sectionId, index) => {
//     setChildToDelete({ sectionId, index });
//     setIsDeleteModalOpen(true);
//   };

//   const handleConfirmDelete = () => {
//     const { sectionId, index } = childToDelete;
//     const updatedSections = sections.map((section) => (section.id === sectionId ? { ...section, children: (section.children || []).filter((_, i) => i !== index) } : section));

//     onSectionsUpdate(updatedSections);

//     // Update parent table
//     if (onChildUpdate) {
//       const updatedParent = { ...item, children: updatedSections.find((s) => s.id === sectionId)?.children || [] };
//       onChildUpdate(updatedParent);
//     }

//     setChildToDelete({ sectionId: null, index: null });
//     setIsDeleteModalOpen(false);
//   };

//   return (
//     <div className="space-y-4 w-full bg-gray-50 p-4">
//       {sections.map((section) => (
//         <div key={section.id} className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
//           <button onClick={() => toggleSection(section.id)} className="bg-[#f1f1f1] w-full px-4 py-3 text-left flex items-center justify-between focus:outline-none">
//             <h4 className="text-sm font-semibold text-gray-900">{section.title}</h4>
//             <span className="w-6 h-6 rounded-full bg-[#4d4a4a] text-white flex items-center justify-center text-sm">{openSections[section.id] ? "-" : "+"}</span>
//           </button>

//           {openSections[section.id] && (
//             <div className="px-4 pb-4 border-t">
//               {section.isChildrenSection ? (
//                 <>
//                   <Table>
//                     <TableHead>
//                       <TableRow>
//                         {["Child", "Age", "Gender", "DOB", "Weight", "Blood Group", "Actions"].map((header) => (
//                           <TableCell key={header}>{header}</TableCell>
//                         ))}
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {(section.children || []).length > 0 ? (
//                         section.children.map((child, index) => (
//                           <TableRow key={index}>
//                             <TableCell>
//                               <div className="flex items-center space-x-3">
//                                 <div className="w-12 h-12 rounded-full overflow-hidden">
//                                   <img src={child.image || Baby} alt={child.name || "Child"} className="w-full h-full object-cover" />
//                                 </div>
//                                 <span className="text-sm font-medium text-[#232526]">{child.name || "—"}</span>
//                               </div>
//                             </TableCell>
//                             {["age", "gender", "dob", "weight", "bloodGroup"].map((field) => (
//                               <TableCell key={field}>{field === "dob" && child[field] ? new Date(child[field]).toLocaleDateString() : child[field] || "—"}</TableCell>
//                             ))}
//                             <TableCell>
//                               <TableActionButton onClick={() => handleDeleteClick(section.id, index)} variant="danger" tooltip="Delete Child" />
//                             </TableCell>
//                           </TableRow>
//                         ))
//                       ) : (
//                         <TableEmptyState title="No children added" action={() => handleAddChildClick(section.id)} actionLabel="Add Child" />
//                       )}
//                     </TableBody>
//                   </Table>

//                   {(section.children || []).length > 0 && (
//                     <div className="pt-4 text-center">
//                       <PrimaryButton onClick={() => handleAddChildClick(section.id)}>Add Another Child</PrimaryButton>
//                     </div>
//                   )}
//                 </>
//               ) : (
//                 <div className="grid grid-cols-2 gap-4 pt-3">
//                   {section.fields?.map((field, i) => (
//                     <div key={i} className={field.isLong ? "col-span-2" : ""}>
//                       <span className="text-sm text-[#74777F]">{field.label}:</span>
//                       {field.isLong ? <p className="text-sm font-medium text-[#232526] mt-1">{field.value}</p> : <div className="text-sm font-medium text-[#232526]">{field.value}</div>}
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       ))}

//       <AddChildModal isOpen={isAddChildModalOpen} onClose={() => setIsAddChildModalOpen(false)} childData={childData} setChildData={setChildData} onSave={handleSaveChild} />

//       <ConfirmModal
//         isOpen={isDeleteModalOpen}
//         title="Delete Child"
//         message={`Are you sure you want to delete ${childToDelete.index !== null ? sections.find((s) => s.id === childToDelete.sectionId)?.children?.[childToDelete.index]?.name : "this child"}?`}
//         confirmLabel="Delete"
//         cancelLabel="Cancel"
//         onCancel={() => setIsDeleteModalOpen(false)}
//         onConfirm={handleConfirmDelete}
//       />
//     </div>
//   );
// };
import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectDarkMode } from "../../../app/store/slices/uiSlice";
import { EyeIcon, PencilIcon, TrashIcon, EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { Table, TableHead, TableBody, TableRow, TableCell, TableEmptyState, TableActionButton, PrimaryButton } from "../ui";
import AddChildModal from "./modals/AddChildModal";
import ConfirmModal from "./ConfirmModal";
import Baby from "../../../assets/images/baby.png";
import { PatientService } from "../../../shared/services/patientService";
import DOMPurify from "dompurify";

export const ExpandedAccordion = ({ sections = [], item, onChildUpdate }) => {
  const darkMode = useSelector(selectDarkMode);
  const [openSections, setOpenSections] = useState({});
  const [isAddChildModalOpen, setIsAddChildModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // "add", "view", "edit"
  const [selectedChildIndex, setSelectedChildIndex] = useState(null);
  const [childData, setChildData] = useState({
    name: "",
    dateOfBirth: "",
    gender: "",
    weightKg: "",
    heightCm: "",
    bloodGroup: "",
    pediatrician: "",
    allergies: "",
    medicalConditions: "",
    specialNotes: "",
    profilePhoto: "",
  });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [childToDelete, setChildToDelete] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleSection = (id) => {
    setOpenSections((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleAddChildClick = () => {
    setSelectedChildIndex(null);
    setModalMode("add");
    setChildData({
      name: "",
      dateOfBirth: "",
      gender: "",
      weightKg: "",
      heightCm: "",
      bloodGroup: "",
      pediatrician: "",
      allergies: "",
      medicalConditions: "",
      specialNotes: "",
      profilePhoto: "",
    });
    setOpenDropdown(null);
    setIsAddChildModalOpen(true);
  };

  const handleViewChild = (index) => {
    const child = (item.children || [])[index];
    setModalMode("view");
    setSelectedChildIndex(index);
    setChildData(child);
    setIsAddChildModalOpen(true);
    setOpenDropdown(null);
  };

  const handleEditChild = (index) => {
    const child = (item.children || [])[index];
    setModalMode("edit");
    setSelectedChildIndex(index);
    setChildData(child);
    setIsAddChildModalOpen(true);
    setOpenDropdown(null);
  };

  const handleSaveChild = async () => {
    if (modalMode === "add") {
      // Call API to create child
      try {
        const payload = {
          ...childData,
          parentId: item.id,
          gender: childData.gender?.toUpperCase(),
          bloodGroup: childData.bloodGroup?.toUpperCase().replace(/\+/g, "_POSITIVE").replace(/-/g, "_NEGATIVE"),
          allergies: childData.allergies ? [childData.allergies] : [],
          medicalConditions: childData.medicalConditions ? [childData.medicalConditions] : [],
          weightKg: parseFloat(childData.weightKg) || 0,
          heightCm: parseFloat(childData.heightCm) || 0,
        };

        const res = await PatientService.createChild(payload);

        if (res?.status === "error") {
          throw new Error(res.message || "Failed to create child");
        }

        const newChild = res?.data?.data || res?.data || res;
        const updatedChildren = [...(item.children || []), newChild];
        const updatedParent = {
          ...item,
          children: updatedChildren,
          numberOfChildren: updatedChildren.length,
        };

        if (onChildUpdate) {
          onChildUpdate(updatedParent);
        }
      } catch (error) {
        console.error("Failed to add child:", error);
        alert("Failed to add child. Please try again.");
        return;
      }
    } else if (modalMode === "edit" && selectedChildIndex !== null) {
      const currentChildren = item.children || [];
      const updatedChildren = currentChildren.map((child, idx) => (idx === selectedChildIndex ? childData : child));
      const updatedParent = {
        ...item,
        children: updatedChildren,
        numberOfChildren: updatedChildren.length,
      };

      if (onChildUpdate) {
        onChildUpdate(updatedParent);
      }
    }

    setIsAddChildModalOpen(false);
  };

  const handleDeleteClick = (index) => {
    setChildToDelete(index);
    setIsDeleteModalOpen(true);
    setOpenDropdown(null);
  };

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  const handleConfirmDelete = async () => {
    if (childToDelete === null) return;

    const currentChildren = item.children || [];
    const childToDeleteData = currentChildren[childToDelete];

    try {
      // Call API to delete child
      if (childToDeleteData?.id) {
        await PatientService.deleteChild(childToDeleteData.id);
      }

      // Remove child from local state
      const updatedChildren = currentChildren.filter((_, i) => i !== childToDelete);
      const updatedParent = {
        ...item,
        children: updatedChildren,
        numberOfChildren: updatedChildren.length,
      };

      if (onChildUpdate) {
        onChildUpdate(updatedParent);
      }
    } catch (error) {
      console.error("Failed to delete child:", error);
      alert("Failed to delete child. Please try again.");
    }

    setChildToDelete(null);
    setIsDeleteModalOpen(false);
  };

  const handleCancelDelete = () => {
    setChildToDelete(null);
    setIsDeleteModalOpen(false);
  };

  // Get the children section
  const childrenSection = sections.find((s) => s.isChildrenSection);
  const children = childrenSection?.children || [];

  return (
    <div className={`space-y-4 w-full p-4 ${darkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      {sections.map((section) => (
        <div key={section.id} className={`rounded-lg border shadow-sm overflow-hidden ${darkMode ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200"}`}>
          <button onClick={() => toggleSection(section.id)} className={`w-full px-4 py-3 text-left flex items-center justify-between focus:outline-none ${darkMode ? "bg-gray-700 hover:bg-gray-600" : "bg-[#f1f1f1] hover:bg-gray-200"}`}>
            <h4 className={`text-sm font-semibold ${darkMode ? "text-white" : "text-gray-900"}`}>{section.title}</h4>
            <span className={`w-6 h-6 rounded-full flex items-center justify-center text-sm ${darkMode ? "bg-gray-600 text-white" : "bg-[#4d4a4a] text-white"}`}>{openSections[section.id] ? "-" : "+"}</span>
          </button>

          {openSections[section.id] && (
            <div className={`px-4 py-4 border-t ${darkMode ? "border-gray-700" : "border-gray-200"}`}>
              {section.isChildrenSection ? (
                <>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {["Child", "DOB", "Gender", "Weight", "Height", "Actions"].map((header) => (
                          <TableCell key={header}>{header}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {children.length > 0 ? (
                        children.map((child, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              <div className="flex items-center space-x-3">
                                <div className="flex items-center justify-center w-10 h-10 rounded-full overflow-hidden bg-[linear-gradient(180deg,#4A9CFF_0%,#4057FE_100%)]">
                                  <img src={child.profilePhoto || Baby} alt={child.name || "Child"} className="w-6 h-6 object-cover flex items-center justify-center" />
                                </div>
                                <span className={`text-sm font-normal ${darkMode ? "text-gray-200" : "text-[#232526]"}`}>{child.name || "—"}</span>
                              </div>
                            </TableCell>
                            <TableCell>{child.dateOfBirth ? new Date(child.dateOfBirth).toLocaleDateString() : "—"}</TableCell>
                            <TableCell>{child.gender || "—"}</TableCell>
                            <TableCell>{child.weightKg ? `${child.weightKg} kg` : "—"}</TableCell>
                            <TableCell>{child.heightCm ? `${child.heightCm} cm` : "—"}</TableCell>
                            <TableCell className="relative">
                              <button onClick={() => toggleDropdown(index)} className={`p-2 rounded-full transition-colors ${darkMode ? "hover:bg-gray-600" : "hover:bg-gray-100"}`}>
                                <EllipsisVerticalIcon className={`w-5 h-5 ${darkMode ? "text-gray-400" : "text-gray-600"}`} />
                              </button>
                              {openDropdown === index && (
                                <div ref={dropdownRef} className={`absolute right-0 top-[-40px] mt-1 w-40 rounded-lg shadow-lg border z-50 ${darkMode ? "bg-gray-700 border-gray-600" : "bg-white border-gray-200"}`}>
                                  <button onClick={() => handleViewChild(index)} className={`w-full px-4 py-2 text-left text-sm flex items-center space-x-2 rounded-t-lg ${darkMode ? "text-gray-200 hover:bg-gray-600" : "text-gray-700 hover:bg-gray-50"}`}>
                                    <EyeIcon className="w-4 h-4" />
                                    <span>View</span>
                                  </button>
                                  <button onClick={() => handleEditChild(index)} className={`w-full px-4 py-2 text-left text-sm flex items-center space-x-2 ${darkMode ? "text-gray-200 hover:bg-gray-600" : "text-gray-700 hover:bg-gray-50"}`}>
                                    <PencilIcon className="w-4 h-4" />
                                    <span>Edit</span>
                                  </button>
                                  <button onClick={() => handleDeleteClick(index)} className={`w-full px-4 py-2 text-left text-sm flex items-center space-x-2 rounded-b-lg ${darkMode ? "text-red-400 hover:bg-red-900/20" : "text-red-600 hover:bg-red-50"}`}>
                                    <TrashIcon className="w-4 h-4" />
                                    <span>Delete</span>
                                  </button>
                                </div>
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableEmptyState title="No children added" message="Use the action button in the parent list to add a child" />
                      )}
                    </TableBody>
                  </Table>

                  {children.length > 0 && (
                    <div className="pt-4 text-center">
                      <PrimaryButton onClick={handleAddChildClick}>Add Another Child</PrimaryButton>
                    </div>
                  )}
                </>
              ) : (
                <div className="grid grid-cols-2 gap-4">
                  {section.fields?.map((field, i) => (
                    <div key={i} className={field.isLong ? "col-span-2" : ""}>
                      <span className={`text-sm ${darkMode ? "text-gray-400" : "text-[#74777F]"}`}>{field.label}:</span>
                      {field.isHtml ? (
                        <div className={`text-sm font-medium mt-1 ${darkMode ? "text-gray-200" : "text-[#232526]"}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(field.value) }} />
                      ) : field.isLong ? (
                        <p className={`text-sm font-medium mt-1 ${darkMode ? "text-gray-200" : "text-[#232526]"}`}>{field.value}</p>
                      ) : (
                        <div className={`text-sm font-medium ${darkMode ? "text-gray-200" : "text-[#232526]"}`}>{field?.value}</div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      ))}

      <AddChildModal isOpen={isAddChildModalOpen} onClose={() => setIsAddChildModalOpen(false)} childData={childData} setChildData={setChildData} onSave={handleSaveChild} isReadOnly={modalMode === "view"} />

      <ConfirmModal
        isOpen={isDeleteModalOpen}
        title="Delete Child"
        message={`Are you sure you want to delete ${childToDelete !== null && children[childToDelete] ? children[childToDelete].name : "this child"}?`}
        confirmLabel="Delete"
        cancelLabel="Cancel"
        onCancel={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </div>
  );
};
